import { m } from '~/paraglide/messages'

/**
 * Web-catalog names for the contents this event grants, keyed by
 * content title key. Register the new keys here when a pass event
 * ships new contents. Land skin keys spell `landskin`, not
 * `land_skin` like the content type.
 */
const titleMessages: Record<string, (() => string) | undefined> = {
  landskin_4_title: m.landskin_4_title,
  landskin_6_title: m.landskin_6_title,
}

/**
 * Resolves a content title key against the web string catalog.
 * Returns null on a catalog miss.
 */
export function getLocalizedMessage(key: string | null): string | null {
  return (key && titleMessages[key]?.()) || null
}
